import React, { Component } from "react";
import { View, StyleSheet } from "react-native";
import Text from "../components_v2/TextFont";
import PropTypes from "prop-types";
import { SimpleIcon } from "../components_v2/Buttons";
import Theme from "../argon-ui/Theme";
import UserMessage from "../viewModels/UserMessage";
import { HStack } from "native-base";
import { IS_WEB } from "../locales/translate";

/**@augments{Component<State,props>} */
class UserMessagePreview extends Component {
  static propTypes = {
    model: PropTypes.shape(),
    style: PropTypes.shape(),
    onPress: PropTypes.func,
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    return;
  }

  handleOnPress = () => {
    typeof this.props.onPress === "function" && this.props.onPress();
  };

  render() {
    var model = UserMessage.parse(this.props.model);
    var injectedStyle = this.props.style;
    var statusStyle = undefined;
    var statusColor = undefined;
    var containerStyle = [styles.container];
    //
    // if (model.seen) {
    //   statusStyle = styles.containerSeen;
    //   statusColor = styles.textMuted;
    // } else {
    if (model.messageLevel == UserMessage.MESSAGE_LEVELS.info) {
      statusStyle = styles.containerInfo;
      statusColor = styles.textInfo;
    }
    if (model.messageLevel == UserMessage.MESSAGE_LEVELS.warning) {
      statusStyle = styles.containerWarning;
      statusColor = styles.textWarning;
    }
    if (model.messageLevel == UserMessage.MESSAGE_LEVELS.danger) {
      statusStyle = styles.containerDanger;
      statusColor = styles.textDanger;
    }
    // }

    //
    // containerStyle.push(statusStyle);

    //if (model.seen) containerStyle.push(styles.containerSeen);
    //
    // if (injectedStyle) containerStyle.push(injectedStyle);

    return (
      <View style={containerStyle}>
        <View style={[{ flex: 1, padding: 10 }]}>
          <View style={styles.heading}>
            <HStack space="2" alignItems="center">
              <SimpleIcon
                color={statusColor.color}
                icon={model.getIcon()}
                size={20}
              />
              <Text style={[styles.title, statusColor]}>{model.title}</Text>
            </HStack>
            <Text style={styles.date}>{model.dateString}</Text>
          </View>
          <Text
            style={[
              styles.messageBody,
              IS_WEB ? { marginRight: 28 } : { marginLeft: 28 },
            ]}
          >
            {model.body}
          </Text>
        </View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    borderRadius: 10,
    padding: 5,
    flexDirection: "row",
    marginBottom: 5,
    backgroundColor: Theme.COLORS.WHITE,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.1,
    shadowRadius: 4,

    elevation: 3,
  },
  containerInfo: {
    borderColor: "#78dbff",
    backgroundColor: "#e8f9ffaa",
  },
  textInfo: { color: "#009bd4" },
  textMuted: { color: Theme.COLORS.MUTED },
  containerWarning: {
    borderColor: "#ffc978",
    backgroundColor: "#fff6e8aa",
  },
  textWarning: { color: "#bd7100" },
  containerDanger: {
    borderColor: "#ff788c",
    backgroundColor: "#ffedf0aa",
  },
  textDanger: { color: "#cc001e" },
  containerSeen: {
    // borderColor: "#b3b3b3",
    backgroundColor: Theme.COLORS.WHITE,
  },
  iconContainer: {
    padding: 10,
    alignItems: "center",
    justifyContent: "center",
    width: 60,
    borderTopStartRadius: 10,
    borderBottomStartRadius: 10,
  },
  heading: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    minHeight: 30,
    marginBottom: 5,
  },
  title: {
    fontWeight: "bold",
    fontSize: 15,
  },
  date: {
    color: Theme.COLORS.MUTED,
    fontSize: 10,
  },
  messageBody: {
    fontSize: 10,
  },
});

export default UserMessagePreview;
